import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';

function App() {
    return (
        <Router>
            <div className="page-wrapper" style={{ background: '#252f43' }}>
                <Header />
                
                <Routes>
                    <Route path="/" element={ <HomePage />} />
                    <Route path="/services" element={ <ServicesPage />} />
                    <Route path="/contact" element={ <ContactPage />} />
                </Routes>

                <Footer />
            </div>
        </Router>
    );
}

export default App;